module.exports = "/_next/static/images/team-staffing-expansion-service-2-49d4f856f9cf892585757d090c905902.webp";